module.exports = __webpack_public_path__ + "img/keiko-fujita.dd370ae6.jpg";